import React from 'react'
import Declaration from './Declaration'
import { getUserInfo, getUserList, getMenuList, getUserRoleId } from 'redux/selectors';
import { connect } from 'react-redux';

function MyDeclaration({ userInfo, userList, menuList, userRoleId }) {
    // Permissions of the "mydeclaration" menu for the logged-in user's role
    const Menulist = menuList?.[userRoleId] || Object.values(menuList || {})[0] || [];
    const declarationMenu = Menulist.find?.((item) => item?.key === "mydeclaration");
    const declarationPermission = {
        create: !!declarationMenu?.permission?.create,
        edit: !!declarationMenu?.permission?.edit,
    };

    const filteruser = userList?.find((item) => item?.userid === userInfo?.userid);
    console.log('filteruser--->',filteruser)
  return (
    <div>
        <Declaration filteruser={filteruser} permission={declarationPermission}/>
    </div>
  )
}
const mapStateToProps = (state) => ({
    userList: getUserList(state),
    userInfo: getUserInfo(state),
    menuList: getMenuList(state),
    userRoleId: getUserRoleId(state),
  });
  export default connect(mapStateToProps, null)(MyDeclaration);